module.exports = __webpack_public_path__ + "static/media/client-hubspot.ebb9c8ab.png";